<template>
  <div id="footer" class="footer">
    <BaseContainer>
      <TappLogo brand-code="dpg" height="48px" />
      <slot />
      <div class="footer__fine-print">
        <span v-html="props.footerText" />
      </div>
    </BaseContainer>
  </div>
</template>

<script setup lang="ts">
  const props = defineProps<{
    footerText: string;
  }>();
</script>

<style scoped lang="postcss">
  .footer {
    --footer-color: var(--colors-gray-700);
    --footer-font-size: var(--font-sizes-sm);

    padding: var(--spacing-8) 0;
    background-color: var(--footer-background-color);

    :deep(.base-container__inner) {
      display: grid;
      gap: var(--spacing-8);
      place-items: center;

      font-size: var(--footer-font-size);
      line-height: var(--line-heights-body);
      color: var(--footer-color);
    }
  }

  .footer__fine-print {
    display: grid;
    place-items: center;
    text-align: center;
    list-style: none;
  }
</style>
